import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProjectManagers } from '../../../operator/user-service/user.interface';
import { UserService } from '../../../operator/user-service/user.service';
import { MultiBuyerStateService } from './multi-buyer-state.service';

@Injectable({ providedIn: 'root' })
export class ServicePartnerUsers {
  constructor(
    private readonly _userService: UserService,
    private readonly _state: MultiBuyerStateService
  ) {}

  merged(companyId: number): Observable<ProjectManagers[]> {
    const selected = this._state.selectedMultiBuyerCompany;
    const isCurrentSPEntity = selected?.id === companyId;

    if (!isCurrentSPEntity && !this._state.servicePartnerEntity(companyId)) {
      return this._userService.getAllBuyerUser(companyId, false);
    }

    const umbrellaId =
      selected?.parentCompany ?? this._state.accessControlConfig.clientId;

    return forkJoin([
      this._userService.getAllBuyerUser(companyId, false),
      this._userService.getAllBuyerUser(umbrellaId, false),
    ]).pipe(
      map(([spUsers, mbUsers]) => {
        const spIds = new Set(spUsers.map((user) => user.id));
        return [...spUsers, ...mbUsers.filter((u) => !spIds.has(u.id))];
      })
    );
  }

  umbrella(companyId: number): Observable<ProjectManagers[]> {
    const selected = this._state.selectedMultiBuyerCompany;
    const isCurrentSPEntity = selected?.id === companyId;

    if (!isCurrentSPEntity && !this._state.servicePartnerEntity(companyId)) {
      return of([]);
    }

    const umbrellaId =
      selected?.parentCompany ?? this._state.accessControlConfig.clientId;
    return this._userService.getAllBuyerUser(umbrellaId, false);
  }
}
